import { render, staticRenderFns } from "./a-order-student-overview-collapse.vue?vue&type=template&id=23ca4772&scoped=true&"
import script from "./a-order-student-overview-collapse.vue?vue&type=script&lang=js&"
export * from "./a-order-student-overview-collapse.vue?vue&type=script&lang=js&"
import style0 from "./a-order-student-overview-collapse.vue?vue&type=style&index=0&id=23ca4772&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ca4772",
  null
  
)

export default component.exports